<script lang="ts">
  import ContentPaste from '~icons/mdi/content-paste';
  import Share from '~icons/mdi/share';
  import ActionButton from '~/components/ActionButton.svelte';
  import Image from '~icons/mdi/image';
  import Link from '~icons/mdi/link';
  import { shareModal } from '~/share/ShareModal.svelte';

  type ShareMethod = 'text' | 'link' | 'img' | undefined;

  let clickedButton: ShareMethod = undefined;

  const handleOpen = async () => {
    shareModal.push();
  };
</script>

<ActionButton
  buttonId="share"
  class={clickedButton ? 'shared' : ''}
  onClick={handleOpen}
>
  {#if !clickedButton}
    <Share color="#03A9F4" />
    Share
  {:else if clickedButton === 'text'}
    <ContentPaste color="#03A9F4" />
    Copied!
  {:else if clickedButton === 'link'}
    <Link color="#03A9F4" />
    Shared Link!
  {:else if clickedButton === 'img'}
    <Image color="#03A9F4" />
    Shared Image!
  {/if}
</ActionButton>

<style lang="scss">
  @use '../theme/theme';
  :global(.action.shared) {
    @include theme.pulse-animation(theme.$tile-blue-dark);
  }
</style>
